import { Accounts } from './Accounts';
import { AwardedFinalEstimates } from './AwardedFinalEstimates';
import { Buildings } from './Buildings';
import { ChangeOrders } from './ChangeOrders';
import { Companies } from './Companies';
import { CompetingBidders } from './CompetingBidders';
import { EstimatesAwarded } from './EstimatesAwarded';
import { EstimatesBid } from './EstimatesBid';
import { Opportunities } from './Opportunities';
import { PointListSystemsLabor } from './PointListSystemsLabor';
import { PointListSystems } from './PointListSystemsService';
import { ProjectModuleCustom } from './ProjectModuleCustom';
import { ProjectModuleExpenses } from './ProjectModuleExpenses';
import { ProjectModuleLabor } from './ProjectModuleLabor';
import { ProjectModuleMaterial } from './ProjectModuleMaterial';
import { ProjectModules } from './ProjectModules';
import { ProjectModuleSubcontractor } from './ProjectModuleSubcontractor';
import { SalesLeads } from './SalesLeads';
import { SalesProjects } from './SalesProjects';
import { ServiceCategories } from './ServiceCategories';
import { ServiceCosts } from './ServiceCosts';
import { ServiceModuleCustom } from './ServiceModuleCustom';
import { ServiceModuleExpenses } from './ServiceModuleExpenses';
import { ServiceModuleLabor } from './ServiceModuleLabor';
import { ServiceModuleMaterial } from './ServiceModuleMaterial';
import { ServiceModules } from './ServiceModules';
import { ServiceModuleSubcontractor } from './ServiceModuleSubcontractor';
import { ServiceSubcategories } from './ServiceSubcategories';
import { ServiceTerms } from './ServiceTerms';

export enum ReportConfigKey {
    AwardedFinalEstimates = 'awarded-final-estimates',
    Buildings = 'buildings',
    ChangeOrders = 'change-orders',
    SalesProjects = 'sales-projects',
    ServiceModules = 'service-modules',
    ServiceTerms = 'service-terms',
    ServiceCosts = 'service-costs',
    PointListSystems = 'point-list-systems',
    PointListSystemsLabor = 'point-list-systems-labor',
    CompetingBidders = 'competing-bidders',
    ServiceCategories = 'service-categories',
    ServiceSubcategories = 'service-subcategories',
    ServiceModuleSubcontractors = 'service-module-subcontractors',
    ServiceModuleExpenses = 'service-module-expenses',
    ServiceModuleCustom = 'service-module-custom',
    ServiceModuleLabor = 'service-module-labor',
    ServiceModuleMaterial = 'service-module-material',
    ProjectModules = 'project-modules',
    ProjectModuleSubcontractors = 'project-module-subcontractors',
    ProjectModuleExpenses = 'project-module-expenses',
    ProjectModuleCustoms = 'project-module-customs',
    ProjectModuleLabors = 'project-module-labors',
    ProjectModuleMaterials = 'project-module-materials',
    SalesLeads = 'sales-leads',
    EstimateBid = 'estimate-bid',
    EstimateAwarded = 'estimate-awarded',
    Opportunities = 'opportunities',
    Companies = 'companies',
    Accounts = 'accounts'
}

export const configs: Record<ReportConfigKey, any> = {
    [ReportConfigKey.AwardedFinalEstimates]: AwardedFinalEstimates,
    [ReportConfigKey.Buildings]: Buildings,
    [ReportConfigKey.ChangeOrders]: ChangeOrders,
    [ReportConfigKey.SalesProjects]: SalesProjects,
    [ReportConfigKey.ServiceModules]: ServiceModules,
    [ReportConfigKey.ServiceTerms]: ServiceTerms,
    [ReportConfigKey.ServiceCosts]: ServiceCosts,
    [ReportConfigKey.PointListSystems]: PointListSystems,
    [ReportConfigKey.PointListSystemsLabor]: PointListSystemsLabor,
    [ReportConfigKey.CompetingBidders]: CompetingBidders,
    [ReportConfigKey.ServiceCategories]: ServiceCategories,
    [ReportConfigKey.ServiceSubcategories]: ServiceSubcategories,
    [ReportConfigKey.ServiceModuleSubcontractors]: ServiceModuleSubcontractor,
    [ReportConfigKey.ServiceModuleExpenses]: ServiceModuleExpenses,
    [ReportConfigKey.ServiceModuleCustom]: ServiceModuleCustom,
    [ReportConfigKey.ServiceModuleLabor]: ServiceModuleLabor,
    [ReportConfigKey.ServiceModuleMaterial]: ServiceModuleMaterial,
    [ReportConfigKey.ProjectModules]: ProjectModules,
    [ReportConfigKey.ProjectModuleSubcontractors]: ProjectModuleSubcontractor,
    [ReportConfigKey.ProjectModuleExpenses]: ProjectModuleExpenses,
    [ReportConfigKey.ProjectModuleCustoms]: ProjectModuleCustom,
    [ReportConfigKey.ProjectModuleLabors]: ProjectModuleLabor,
    [ReportConfigKey.ProjectModuleMaterials]: ProjectModuleMaterial,
    [ReportConfigKey.SalesLeads]: SalesLeads,
    [ReportConfigKey.EstimateBid]: EstimatesBid,
    [ReportConfigKey.EstimateAwarded]: EstimatesAwarded,
    [ReportConfigKey.Opportunities]: Opportunities,
    [ReportConfigKey.Companies]: Companies,
    [ReportConfigKey.Accounts]: Accounts
};
